import { useState } from "react";
import { Switch } from "@mui/material";
import { t } from "i18next";
import api from "../../helpers/api/Api";
import { showStatus } from "../../helpers/api/errors/ShowStatus";
import CustomDialog from "../Dialog";

function DisabledSwitch({ disableUrl, item, itemName, itemCName, disabled }) {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(item.disabled);
  const [openDialog, setOpenDialog] = useState(false);

  const onChangeSwitch = () => {
    setOpenDialog(true);
  }

  const changeDisabled = () => {
    setLoading(true);
    const snackArgs = {
      item: itemName,
      op: checked === "1" ? t("global.disabled") : t("global.enabled")
    };

    const disabled = checked === "1" ? "0" : "1";
    const formData = new FormData();
    formData.append("uid", item.id);
    formData.append('disabled', disabled);

    api.post(disableUrl, formData)
      .then((response) => {
        setLoading(false);
        showStatus(response.data.status, snackArgs);
        handleCloseDialog();
        if (response.data.status === "success") {
          setChecked(disabled);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleCloseDialog();
        showStatus("error", snackArgs);
      });
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  return (
    <div>
      <Switch
        checked={checked == "1"}
        onChange={onChangeSwitch}
        color="success"
        disabled={disabled}
      />

      <CustomDialog
        open={openDialog}
        text={t("message.confirm", {
          item: itemCName ? itemCName : itemName,
          id: "",
          op: t(`global.${checked === "1" ? "disable" : "enable"}`) })
        }
        handleClose={handleCloseDialog}
        onAccept={changeDisabled}
        loading={loading}
      />
    </div>
  )
}

export default DisabledSwitch;
